module.exports = __webpack_public_path__ + "static/media/pizza-slice.7aefbae3.svg";